export default {
  cdn: 'https://wa.cdn-surfline.com/webapp/',
  bwHost: '//www.buoyweather.com',
  bwHostBeanstalk: '//bw-web-prod.elasticbeanstalk.com',
  cmsCdn: '//cdn-prod.buoyweather.com/uploads',
  servicesURL: 'https://services.surfline.com',
  bwServicesURL: 'https://services.buoyweather.com',
  bwApiUrl: 'https://www.buoyweather.com',
  scienceDataURL: 'http://science-data-service.prod.surfline.com/graphql',
  legacyUrl: '//www.buoyweather.com',
  appKeys: {
    segment: 'CvbvzychXPuprLT31PUJjn2797aKS8Ez',
    newrelic: '',
    splitio: process.env.SPLITIO_AUTHORIZATION_KEY || 'in20v2ebf6q1gh97ldcn1bp8ufdbr404e514',
  },
  links: {
    home: '//www.buoyweather.com',
    about: 'https://www.buoyweather.com/info.jsp?id=21739',
    advertise: 'https://www.buoyweather.com/advertising/mediakit/',
    terms: 'https://www.buoyweather.com/terms',
    privacy: 'https://www.buoyweather.com/privacy',
    funnel: {
      login: 'https://www.buoyweather.com/sign-in',
      logout: '//www.buoyweather.com/sign-out',
      try_premium_mobile: 'https://www.buoyweather.com/upgrade/',
      try_premium: 'https://www.buoyweather.com/upgrade/',
      registerNow: 'https://www.buoyweather.com/upgrade/',
      renew: 'https://www.buoyweather.com/upgrade/',
      gift_cards: 'https://www.buoyweather.com/gift-cards/',
    },
    account: {
      information: 'https://www.buoyweather.com/account/',
      payment: 'https://www.buoyweather.com/account/',
      contact: '//www.buoyweather.com/info.jsp?id=21736',
    },
    support: 'https://support.buoyweather.com/hc/en-us',
    careers: 'https://careers.surfline.com/join-our-team/',
    sitemap: 'http://www.buoyweather.com/sitemap/',
    surfline: 'https://www.surfline.com/',
    magicseaweed: 'https://www.magicseaweed.com/',
    fishtrack: 'https://www.fishtrack.com/',
  },
  cookies: {
    domain: '.www.buoyweather.com',
  },
  maptiler: {
    key: process.env.MAPTILER_API_KEY,
    baseMapId: process.env.MAPTILER_BASEMAP_ID,
  },
  arcgis: {
    token: process.env.ARCGIS_API_KEY,
  },
  appStore: {
    affiliateAt: process.env.BW_APP_STORE_AFFILIATE_AT || '',
    affiliatePt: process.env.BW_APP_STORE_AFFILIATE_PT || '',
  },
};



// WEBPACK FOOTER //
// ./src/config/envs/production.js